import { z } from 'zod';

/**
 * Мягкая валидация email для форм проверки контрагента.
 * Пропускает unicode (включая кириллические гомоглифы и IDN-домены),
 * проверяет только структуру: непустой local part, @, домен с точкой.
 * Сервер решает фактическую валидность.
 */
export const looseEmailSchema = z
    .string()
    .min(1, 'Email is required')
    .refine((v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/u.test(v), 'Invalid email format');


/** Булева проверка адреса по той же мягкой схеме. */
export const isEmail = (value: string): boolean => looseEmailSchema.safeParse(value).success;
